// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"270bb5b9","703":"a45385fe","787":"d4bc0bd7"}[chunkId] + ".chunk.js";
};